import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import { Select } from 'antd';

import { ShopStore, CurrentUserStore, ReportsDataStore } from 'stores';
import { UserRoles } from 'stores/Classes/UserObject';
import DeviceStore from 'stores/Classes/DeviceStore';

const { Option } = Select;
const { device } = DeviceStore;

const Container = styled.div`
  &&& {
    margin: 10px 0px;
    display: flex;

    --select-width: ${device === 'mobile' ? '100%' : '20rem'};

    .ant-select {
      width: var(--select-width);
    }

    p {
      margin: auto 0px;
    }

    @media only screen and (max-width: 768px) {
      flex-direction: column;
      .ant-select {
        width: 100%;
      }
    }

    @media only screen and (min-width: 768px) {
      p {
        text-align: ${(props) => props.pathname === '/location' && 'right'};
        width: ${(props) => (props.pathname === '/location' ? '12em' : '6em')};
        margin-right: ${(props) => props.pathname === '/location' && '1em'};
      }
    }
  }
`;

const DealershipChooser = ({ location, onLoad }) => {
  useEffect(() => {
    if (CurrentUserStore.user.role !== UserRoles.customer) {
      if (!ShopStore.loaded && !ShopStore.pending) {
        ShopStore.getShops().then(() => {
          // restore last selected fleet from localStorage
          const savedFleetId = localStorage.getItem('selectedFleetId');
          // Removed functionality to get from localStorage, user should loggin to default fleet

          // if (savedFleetId && ShopStore.data.has(parseInt(savedFleetId))) {
          // ShopStore.setCurrentShop(parseInt(savedFleetId));
          // } else

          if (
            CurrentUserStore.user.defaultShopId &&
            ShopStore.data.has(CurrentUserStore.user.defaultShopId)
          ) {
            ShopStore.setCurrentShop(CurrentUserStore.user.defaultShopId);
          }
          if (onLoad && typeof onLoad === 'function') {
            onLoad();
          }
        });
      } else if (ShopStore.loaded && onLoad && typeof onLoad === 'function') {
        onLoad();
      } else if (
        ShopStore.loaded &&
        !ShopStore.currentShop &&
        CurrentUserStore.user.defaultShopId &&
        ShopStore.data.has(CurrentUserStore.user.defaultShopId)
      ) {
        ShopStore.setCurrentShop(CurrentUserStore.user.defaultShopId);
      }
    }
  }, [onLoad]);

  const handleDealershipChange = (newDealership) => {
    ShopStore.setCurrentShop(newDealership);
    // Save the selected fleet to localStorage
    // localStorage.setItem('selectedFleetId', newDealership.toString());
    ReportsDataStore.reload();
  };

  if (!['admin', 'dealership'].includes(CurrentUserStore.user.role)) {
    return null;
  }

  // Extract and sort parent shops
  const sortedParentShops = _.chain(Array.from(ShopStore.data.values()))
    .filter((shop) => !shop.id_parent_shop)
    .sortBy((shop) => shop.name)
    .value();

  // Extract and sort child shops
  const sortedChildShops = _.chain(Array.from(ShopStore.data.values()))
    .filter((shop) => shop.id_parent_shop)
    .sortBy((shop) => shop.name)
    .value();

  // Combine parent and child shops
  const combinedShops = sortedParentShops.concat(sortedChildShops);

  return (
    <Container pathname={location.pathname}>
      <p>Select Fleet:</p>

      <div>
        <Select
          showSearch
          placeholder="Select a Fleet"
          optionFilterProp="children"
          loading={!ShopStore.loaded}
          onChange={handleDealershipChange}
          value={
            ShopStore.currentShop
              ? parseInt(ShopStore.currentShop.id)
              : undefined
          }
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          data-testid="fleet-selector"
        >
          {combinedShops.map((shop) => (
            <Option key={shop.id} value={shop.id}>
              {shop.name}
            </Option>
          ))}
        </Select>
      </div>
    </Container>
  );
};

DealershipChooser.propTypes = {
  location: PropTypes.object.isRequired,
  onLoad: PropTypes.func,
};

export default withRouter(observer(DealershipChooser));
